import SafeApply from '@/angularBridgeCode/utilities/safeApply';

import {
  ngVueEventBus,
  EVENT_SAVED_INSIGHTS_UPDATED,
  EVENT_SHOW_TOASTER,
  EVENT_STOP_PLAYER,
  EVENT_CAMPAIGNS_UPDATED,
  EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED
} from '@/angularBridgeCode/utilities/ngVueEventBus';

export default class Utilities {
  /** @ngInject **/
  constructor(toaster, $state, $stateParams, angularDebugInfoEnabled) {
    this.safeApply = SafeApply;
    this.ngVueEventBus = ngVueEventBus;
    this.ngVueEvents = {
      EVENT_SAVED_INSIGHTS_UPDATED,
      EVENT_SHOW_TOASTER,
      EVENT_STOP_PLAYER,
      EVENT_CAMPAIGNS_UPDATED,
      EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED
    };

    this.toaster = toaster;
    this.$state = $state;
    this.stateParams = $stateParams;
    this.debug = angularDebugInfoEnabled;
  }

  getPropFromUrlParams(propName) {
    return this.stateParams[propName];
  }

  showToaster(type, message) {
    this.toaster.pop(type, message);
    this.ngVueEventBus.$emit(EVENT_SHOW_TOASTER);
  }

  showToasterWithOptions(options) {
    this.toaster.pop(options);
    this.ngVueEventBus.$emit(EVENT_SHOW_TOASTER);
  }

  clearExportToaster(toastId) {
    this.toaster.clear('miscellaneous-toaster', toastId);
  }

  emitToasterUpdateEvent() {
    this.ngVueEventBus.$emit(EVENT_SHOW_TOASTER);
  }

  errorHandler(error) {
    let message = 'Operation failed: an error has occurred';
    try {
      if (error?.data) {
        if (error.data.modelState && error.data.modelState[''][0]) {
          message = error.data.modelState[''][0];
        } else if (error.data.errors && Array.isArray(error.data.errors) && typeof error.data.errors[0] === 'string') {
          message = error.data.errors[0];
        } else if (error.data.errors && typeof error.data.errors === 'object') {
          // ASP.NET Core validation format: { errors: { fieldName: [messages] } }
          const firstKey = Object.keys(error.data.errors)[0];
          if (firstKey && error.data.errors[firstKey] && error.data.errors[firstKey][0]) {
            message = error.data.errors[firstKey][0];
          }
        } else if (
          error.data.failReason &&
          error.data.failReason.errorMessage
        ) {
          message = error.data.failReason.errorMessage;
        } else if (error.data.message) {
          message = error.data.message;
        } else if (error.data.title) {
          // ASP.NET Core validation format uses 'title' instead of 'message'
          message = error.data.title;
        } else if (
          typeof error.data === 'string' ||
          error.data instanceof String
        ) {
          message = error.data;
        }
      }
      if (
        error &&
        (typeof error === 'string' ||
        error instanceof String)
      ) {
        message = error;
      }

      if (error && this.debug) {
        console.error(error);
      }
    } catch (e) {
      console.error(e);
    }
    if (typeof message !== 'string') message = 'Operation failed: an error has occurred';
    message = message.trim();
    message = message.charAt(0).toUpperCase() + message.slice(1);
    this.showToaster('error', message);
  }

  openInNewTab({ routeName, paramsObj }) {
    const url = this.$state.href(routeName, paramsObj);
    window.open(url, '_blank');
  }

  goToRoute({ routeName, paramsObj }) {
    this.$state.go(routeName, paramsObj);
  }

  downloadContentAsFile({ contentAsString, mimeType, fileName }) {
    const blob = new Blob([contentAsString], {
      type: `${mimeType};charset=utf-8;`
    });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
